import { Formik, FormikHelpers } from "formik";
import { useFormSubmit } from "melco-shared-logic";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
import * as Yup from "yup";
import { useAddNewForward } from "../../../hooks/urlforward/useAddNewForward";
import { } from "../../../hooks/items/useShouldShowWarning";
import { DisplayNewForwardForm } from "./DisplayNewForwardForm";


export type SubmitAction = "add";


export type AddNewForwardFormValueType = {
    key: string;
    target: string;
};

type AddNewForwardFormProps = {

    referenceDrawer: DrawerType
    onCloseDrawer: (closeDrawer: boolean) => void;
};

export const AddNewForwardForm: React.FC<AddNewForwardFormProps> = ({
    referenceDrawer,
    onCloseDrawer
}) => {
    //  const { t } = useTranslation();
    //  const token = useUserToken();
    const addNewForward = useAddNewForward();


    const onSubmit = async (
        values: AddNewForwardFormValueType,
        formikHelpers: FormikHelpers<AddNewForwardFormValueType>
    ) => {

        console.log(values)
        if (values.key != undefined && values.key != null && values.key != ''
            && values.target != undefined && values.target != null && values.target != '') {
        }
        await onAddNewForward(values, formikHelpers, { isManuallyResettingForm: true });

    };


    const initialValues: AddNewForwardFormValueType = {
        key: "",
        target: ""
    };

    const handleAddNewForward = async (
        values: AddNewForwardFormValueType,
        formikHelpers: FormikHelpers<AddNewForwardFormValueType>,
        options: {
        }
    ) => {
        const response = await addNewForward(values);
        if (response?.success) {
            formikHelpers.resetForm();
            onCloseDrawer(false);
        }
    };

    const formSubmitToAddNewForward = () => {

        return [
            async (
                values: AddNewForwardFormValueType,
                formikHelpers: FormikHelpers<AddNewForwardFormValueType>
            ) => {

                return handleAddNewForward(values, formikHelpers, {});
            },
            {
                translationOptions: {
                    batchNumber: 1,
                },
                translationPrefix: [
                    "url_forward.actions",
                    "add_new",
                ].join("."),
                onError: () => {
                    // refetch entity from server
                },
            },
        ] as const;
    };

    const onAddNewForward = useFormSubmit(...formSubmitToAddNewForward());

    const AddNewForwardSchema = Yup.object().shape({
        key: Yup.string().required(),
        target: Yup.string().required(),
    });


    return (
        <>
            <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={AddNewForwardSchema}
            >

                <DirtyFormPrompt>
                    <DisplayNewForwardForm></DisplayNewForwardForm>

                </DirtyFormPrompt>
            </Formik>
        </>

    );
};
